import { getDay } from "../utils/date";

export const PURCHASE_SALES_PIE_CHART_DATAS = [
  { label: "(주)선진플랜트", data: 50000000 },
  { label: "(주)조일특수보일러", data: 34220000 },
  { label: "대성플랜트", data: 34200000 },
  { label: "(주)뉴진성테크", data: 24220000 },
  { label: "크리에이트잇", data: 12200000 },
  { label: "기타", data: 14200000 },
];

export const SALES_CHART_DATAS = [
  { label: getDay(6,"D ddd"), data: 243 },
  { label: getDay(5,"D ddd"), data: 343 },
  { label: getDay(4,"D ddd"), data: 2643 },
  { label: getDay(3,"D ddd"), data: 1220 },
  { label: getDay(2,"D ddd"), data: 1643 },
  { label: getDay(1,"D ddd"), data: 1643 },
  { label: getDay(0,"D ddd"), data: 1220 },
];
export const SALES_CHART_DATAS2 = [
  { label: getDay(6,"D ddd"), data: 2543 },
  { label: getDay(5,"D ddd"), data: 2543 },
  { label: getDay(4,"D ddd"), data: 3643 },
  { label: getDay(3,"D ddd"), data: 3220 },
  { label: getDay(2,"D ddd"), data: 2643 },
  { label: getDay(1,"D ddd"), data: 3643 },
  { label: getDay(0,"D ddd"), data: 4220 },
];
export const ATTENDANCE_STATUS = [
  { user: { name: "홍길동" }, data: "휴가" },
  { user: { name: "송효진" }, data: "재택근무" },
  { user: { name: "이동범" }, data: "해외출장" },
];

export const BOND_DEBT_DATAS = [
  {
    clientName: "(주)삼화피앤티 제2공장",
    code: "932",
    preBalance: "-11,491,953",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "-11,491,953",
  },
  {
    clientName: "(주)선기술",
    code: "915",
    preBalance: "-10,000,000",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "-10,000,000",
  },
  {
    clientName: "(주)에이디티캡스 안양지점",
    code: "853",
    preBalance: "231,000",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "231,000",
  },
  {
    clientName: "(주)에이툴피아",
    code: "850",
    preBalance: "8,026,645",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "8,026,645",
  },
  {
    clientName: "(주)영등포특수강",
    code: "848",
    preBalance: "16,236,748",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "16,236,748",
  },
  {
    clientName: "(주)우리엠텍",
    code: "929",
    preBalance: "-219,390,051",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "-219,390,051",
  },
  {
    clientName: "(주)포밍코리아",
    code: "956",
    preBalance: "-3,185,996",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "-3,185,996",
  },
  {
    clientName: "(주)한라캐스트",
    code: "928",
    preBalance: "-6,048,823",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "-6,048,823",
  },
  {
    clientName: "㈜LG유플러스",
    code: "862",
    preBalance: "30,490",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "30,490",
  },
  {
    clientName: "구미에이테크솔루션(주)",
    code: "914",
    preBalance: "-10,794,194",
    salesAmount: "0",
    purchaseAmount: "0",
    salesCount: "0",
    purchaseCount: "0",
    lastBalance: "-10,794,194",
  },
];

export const USER_LIST = [
  {
    name: "김재환",
    grade: "대표",
    userImg: "",
    part: "",
    email: "createit@createit.link",
  },
  {
    name: "석지원",
    grade: "개발자",
    userImg: "",
    part: "개발팀",
    email: "seok@createit.link",
  },
  {
    name: "이현구",
    grade: "개발자",
    userImg: "",
    part: "개발팀",
    email: "hyun@createit.link",
  },
  {
    name: "김가람",
    grade: "개발자",
    userImg: "",
    part: "개발팀",
    email: "garam@createit.link",
  },
  {
    name: "송효진",
    grade: "디자이너",
    userImg: "",
    part: "디자인팀",
    email: "zeze@createit.link",
  },
  {
    name: "이동범",
    grade: "개발자",
    userImg: "",
    part: "개발팀",
    email: "bumi900@createit.link",
  },
  {
    name: "김범준",
    grade: "개발자",
    userImg: "",
    part: "개발팀",
    email: "kbj@createit.link",
  },
]

export const DIVISION_LSIT = [
  {
    title: "CreateIT",
    key: "company",
    children: [
      {
        title: "개발부",
        key: "develop",
        children: [
          {
            title: "웹개발",
            key: "dev-web",
            children: [],
          },
          {
            title: "앱개발",
            key: "dev-app",
            children: [],
          },
          {
            title: "서버개발",
            key: "dev-server",
            children: [],
          },
        ],
      },
      {
        title: "디자인부",
        key: "design",
        children: [
          {
            title: "웹디자인",
            key: "web-design",
            children: [],
          },
          {
            title: "앱디자인",
            key: "app-design",
            children: [],
          },
        ],
      },
    ],
  },
]

export const GOURP_LSIT = [
  {
    title: "CreateIT",
    key: "company",
    children: [
      {
        title: "경리대행TFT",
        key: "develop",
      },
      {
        title: "근무일정TFT",
        key: "design",
      },
    ],
  },
]

export const GRADE_LSIT = [
  {
    title: "CreateIT",
    key: "company",
    children: [
      {
        title: "대표",
        key: "ceo",
      },
      {
        title: "개발자",
        key: "develop",
      },
      {
        title: "디자이너",
        key: "design",
      },
    ],
  },
]

